import React from 'react'

import { formatContractType, formatSalary, formatStartDate } from './format'
import { PayRange } from './offer/type'

type formatProps = {
  value?: string | undefined
} & object

export function withFormatContractType<T extends formatProps>(
  Component: React.FC<T>,
): React.FC<T & { contract?: string }> {
  return ({ contract, ...rest }) => {
    const props = {
      ...(rest as T),
      value: contract ? formatContractType(contract) : undefined,
    }
    return <Component {...props} />
  }
}

export function withFormatStartDate<T extends formatProps>(
  Component: React.ComponentType<T>,
): React.FC<T & { startDate: Date | string }> {
  return ({ startDate, ...rest }) => {
    const props = {
      ...(rest as T),
      value:
        startDate instanceof Date
          ? formatStartDate(startDate.toISOString())
          : formatStartDate(startDate),
    }
    return <Component {...props} />
  }
}

export function withFormatSalary<T extends formatProps>(
  Component: React.ComponentType<T>,
): React.FC<T & { salary?: PayRange }> {
  return ({ salary, ...rest }) => {
    const props = {
      ...(rest as T),
      value: salary ? formatSalary(salary) : undefined,
    }
    return <Component {...props} />
  }
}
